import React, { useContext, Suspense } from 'react';

import { EntityContext } from 'context/entityContext';

import Layout from 'components/styled/Layout/Layout';
import Message from 'components/base/Message/Message';
import PerformanceBreakdownLoader from 'components/data-containers/PerformanceBreakdown/SkeletonLoader';
import PerformanceTrendSkeleton from 'components/data-containers/PerformanceTrend/SkeletonLoader';
import SocialFollowersSkeleton from 'components/data-containers/SocialFollowers/components/SkeletonLoader';

const SocialArtistPerformanceTrend = React.lazy(() =>
  import(
    'components/data-containers/PerformanceTrend/SocialArtistPerformanceTrend/SocialArtistPerformanceTrend'
  )
);

const SocialBreakdown = React.lazy(() =>
  import('components/data-containers/SocialBreakdown/SocialBreakdown')
);

const SocialFollowers = React.lazy(() =>
  import('components/data-containers/SocialFollowers')
);

const Social: React.FC = () => {
  const { compareMode } = useContext(EntityContext);

  if (compareMode === 'country') {
    return (
      <Layout.MaxWidth>
        <Message>
          At this moment it is not possible to compare social data by country.
        </Message>
      </Layout.MaxWidth>
    );
  }
  const title = 'Artist Social Followers';

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      {
        <Suspense fallback={<SocialFollowersSkeleton title={title} />}>
          <SocialFollowers glossarySlug="kpis/social-kpis" title={title} />
        </Suspense>
      }

      <Suspense
        fallback={
          <PerformanceTrendSkeleton
            title="Artist Social Performance"
            showComplementary
            isNarrowScreen
          />
        }
      >
        <SocialArtistPerformanceTrend />
      </Suspense>

      <Suspense
        fallback={
          <PerformanceBreakdownLoader
            barCount={3}
            title="Artist Social Breakdown"
          />
        }
      >
        <SocialBreakdown title="Artist Social Breakdown" />
      </Suspense>
    </div>
  );
};

export default Social;
